import { useSelector } from "react-redux";

const useRole = () => {
    const role = useSelector((state) => state?.Login?.userDetails?.role_id);
    return role;
}

export default useRole